<template>
<div class="services-page">
  <div class="hw-card">
    <h1 class="hw-title">Vos prestations</h1>
    <p class="hw-subtitle">Sélectionnez les services souhaités</p>

    <div class="service-list">
      <!-- Coupe -->
      <div class="service-item" :class="{ active: services.includes('coupe') }">
        <div class="service-label">
          <CheckBox id="coupe" name="coupe" value="coupe" v-model="services" @change="validate()" />
          <label for="coupe" class="service-text">Coupe</label>
        </div>
        <div v-show="services.includes('coupe') && length != 'xs' && length != 's'" class="sub-options">
          <div class="radio-label">
            <RadioButton id="coupeComplete" name="coupeDetails" value="coupeComplete" v-model="coupeDetails" />
            <label for="coupeComplete">Complète</label>
          </div>
          <div class="radio-label">
            <RadioButton id="pointes" name="coupeDetails" value="pointes" v-model="coupeDetails" />
            <label for="pointes">Pointes uniquement (sans dégradé)</label>
          </div>
        </div>
      </div>

      <!-- Brushing -->
      <div class="service-item" :class="{ active: services.includes('brushing') }">
        <div class="service-label">
          <CheckBox id="brushing" name="brushing" value="brushing" v-model="services" @change="validate()" />
          <label for="brushing" class="service-text">Séchage / Mise en forme</label>
        </div>
      </div>

      <!-- Couleur -->
      <div class="service-item" :class="{ active: services.includes('couleur') }" v-show="!couleurDisabled">
        <div class="service-label">
          <CheckBox id="couleur" name="couleur" value="couleur" v-model="services" @change="validate()" />
          <label for="couleur" class="service-text">Couleur</label>
        </div>
        <div v-show="services.includes('couleur')" class="sub-options">
          <div class="radio-label">
            <RadioButton id="couleurComplete" name="couleurDetails" value="couleurComplete" v-model="couleurDetails" />
            <label for="couleurComplete">Complète</label>
          </div>
          <div class="radio-label">
            <RadioButton id="racines" name="couleurDetails" value="racines" v-model="couleurDetails" />
            <label for="racines">Racines uniquement</label>
          </div>
        </div>
      </div>

      <!-- Mèches -->
      <div class="service-item" :class="{ active: services.includes('mèches') }" v-show="!mechesDisabled">
        <div class="service-label">
          <CheckBox id="mèches" name="mèches" value="mèches" v-model="services" @change="validate()" />
          <label for="mèches" class="service-text">Mèches</label>
        </div>
        <div v-show="services.includes('mèches')" class="sub-options">
          <div class="radio-label">
            <RadioButton id="mecheComplete" name="mecheDetails" value="mecheComplete" v-model="mecheDetails" />
            <label for="mecheComplete">Tête complète</label>
          </div>
          <div class="radio-label">
            <RadioButton id="partielles" name="mecheDetails" value="partielles" v-model="mecheDetails" />
            <label for="partielles">Mèches parsemées</label>
          </div>
        </div>
      </div>

      <!-- Lissage -->
      <div class="service-item" :class="{ active: services.includes('lissage') }" v-if="length != 'xs'" v-show="!lissageDisabled">
        <div class="service-label">
          <CheckBox id="lissage" name="lissage" value="lissage" v-model="services" v-if="length != 'xs'" @change="validate()" />
          <label for="lissage" class="service-text">Lissage</label>
        </div>
      </div>

      <!-- Permanente -->
      <div class="service-item" :class="{ active: services.includes('permanente') }" v-if="length != 'xs'" v-show="!permanenteDisabled">
        <div class="service-label">
          <CheckBox id="permanente" name="permanente" value="permanente" v-model="services" @change="validate()" />
          <label for="permanente" class="service-text">Permanente</label>
        </div>
      </div>

      <!-- Barbe -->
      <div class="service-item" :class="{ active: services.includes('barbe') }">
        <div class="service-label">
          <CheckBox id="barbe" name="barbe" value="barbe" v-model="services" @change="validate()" />
          <label for="barbe" class="service-text">Barbe</label>
        </div>
      </div>
    </div>

    <small v-show="validationErrors.services && submitted" class="form-error">
      Merci de choisir au moins un service
    </small>
  </div>

  <div class="hw-card info-card">
    <div class="info-row">
      <i class="pi pi-phone info-icon"></i>
      <p class="info-text">
        Si les services que vous souhaitez ne sont pas dans cette liste, que vous
        avez des questions ou besoin de conseils, ou en cas de doute, vous pouvez
        prendre rendez-vous par téléphone au <a href="tel:0782381360">078 238 13 60</a>
      </p>
    </div>
  </div>

  <div class="hw-actions">
    <button class="hw-btn hw-btn-secondary" @click="previousPage()">
      <i class="pi pi-arrow-left"></i>
      Retour
    </button>
    <button class="hw-btn hw-btn-primary" @click="nextPage()">
      Suivant
      <i class="pi pi-arrow-right"></i>
    </button>
  </div>
</div>
</template>

<style scoped>
.services-page {
  text-align: left;
}

.service-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.service-item {
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.75rem 1rem;
  background: #f8fafc;
  transition: all 0.2s ease;
}

.service-item.active {
  border-color: #3b82f6;
  background: #eff6ff;
}

.service-label {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.service-text {
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  cursor: pointer;
}

.sub-options {
  margin-top: 0.6rem;
  margin-left: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #e2e8f0;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.88rem;
  color: #475569;
  -webkit-tap-highlight-color: transparent;
}

.radio-label label {
  cursor: pointer;
}

.form-error {
  display: block;
  color: #dc2626;
  font-size: 0.8rem;
  margin-top: 0.6rem;
}

.info-card {
  margin-top: 0.75rem;
  padding: 1rem;
}

.info-row {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.info-icon {
  color: #3b82f6;
  font-size: 1.1rem;
  margin-top: 0.15rem;
  flex-shrink: 0;
}

.info-text {
  margin: 0;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.5;
}

.info-text a {
  color: #3b82f6;
  font-weight: 600;
  text-decoration: none;
}

.info-text a:hover {
  text-decoration: underline;
}

@media (max-width: 480px) {
  .sub-options {
    margin-left: 1.5rem;
  }
}
</style>

<script setup>
import { defineEmits, ref, onMounted } from "vue";

import { storeToRefs } from 'pinia'
import { useMainStore } from '../store'
import {getFrom, getTo} from  '../dateUtils.js'
import { computeAppointmentDuration, defaultAppointmentDurationConfig, normalizeAppointmentDurationConfig } from '../helpers/appointmentDurationRules.js'

import axios from 'axios'

const store = useMainStore();
const { length  } = storeToRefs(useMainStore())

const validationErrors = ref({});

var submitted = ref(false)
const durationConfig = ref(defaultAppointmentDurationConfig());

 onMounted(async () => {
    if(!store.length)
    {
        emit('go-home');
        return;
    }

    try {
      const response = await axios.get(`${process.env.VUE_APP_API_URL}/Settings/public-appointment-duration-config`);
      durationConfig.value = normalizeAppointmentDurationConfig(response.data);
    } catch (error) {
      console.log('Unable to fetch appointment duration config, using defaults.', error);
      durationConfig.value = defaultAppointmentDurationConfig();
    }
});

const emit = defineEmits(['next-page', 'previous-page', 'go-home', 'go-confirm']);

function nextPage() {
  submitted.value = true;
    if(validateForm())
    {
 computeTime();
  store.$patch((state) => {
        state.days = {};
        state.loading = true;
        state.services = services.value;
        state.serviceDetails = {
          coupeDetails: coupeDetails.value,
          couleurDetails: couleurDetails.value,
          mecheDetails: mecheDetails.value
        };
      });

      console.log(`${process.env.VUE_APP_API_URL}/Appointments?from=${getFrom(new Date())}&to=${getTo(new Date())}&duration=${store.duration}`)
   axios
      .get(`${process.env.VUE_APP_API_URL}/Appointments?from=${getFrom(new Date())}&to=${getTo(new Date())}&duration=${store.duration}`)
      .then(response => {
          store.$patch((state) => {
        state.days = response.data;
        state.loading = false;
      });
      })
  emit("next-page", { pageIndex: 2 });
    }
}

function previousPage() {
  emit("previous-page", { pageIndex: 2 });
}

const services = ref([]);

const couleurDisabled = ref(false);
const mechesDisabled = ref(false);
const lissageDisabled = ref(false);
const permanenteDisabled = ref(false);

const coupeDetails = ref("coupeComplete");
const couleurDetails = ref("couleurComplete");
const mecheDetails = ref("mecheComplete");


const brushingAutoAdded = ref(false);

function removeFromArray(arr, value) {
  let idx;
  while ((idx = arr.indexOf(value)) !== -1) {
    arr.splice(idx, 1);
  }
}

function validate() {
  enableAll();

  const majorServices = ["coupe", "lissage", "permanente", "couleur", "mèches"];
  const hasMajorService = majorServices.some(s => services.value.includes(s));

  // Auto-add brushing when a major service is selected
  if (hasMajorService && !services.value.includes("brushing")) {
    services.value.push("brushing");
    brushingAutoAdded.value = true;
  }

  // Auto-remove brushing when all major services are unchecked
  if (!hasMajorService && brushingAutoAdded.value && services.value.includes("brushing")) {
    removeFromArray(services.value, "brushing");
    brushingAutoAdded.value = false;
  }

  // Disable incompatible services and remove them from selection
  if (services.value.includes("permanente")) {
    lissageDisabled.value = true;
    couleurDisabled.value = true;
    mechesDisabled.value = true;
    removeFromArray(services.value, "lissage");
    removeFromArray(services.value, "couleur");
    removeFromArray(services.value, "mèches");
  }

  if (services.value.includes("lissage")) {
    permanenteDisabled.value = true;
    couleurDisabled.value = true;
    mechesDisabled.value = true;
    removeFromArray(services.value, "permanente");
    removeFromArray(services.value, "couleur");
    removeFromArray(services.value, "mèches");
  }

  if (services.value.includes("couleur")) {
    permanenteDisabled.value = true;
    lissageDisabled.value = true;
    removeFromArray(services.value, "permanente");
    removeFromArray(services.value, "lissage");
  }

  if (services.value.includes("mèches")) {
    permanenteDisabled.value = true;
    lissageDisabled.value = true;
    removeFromArray(services.value, "permanente");
    removeFromArray(services.value, "lissage");
  }
}

function enableAll() {
  couleurDisabled.value = false;
  mechesDisabled.value = false;
  lissageDisabled.value = false;
  permanenteDisabled.value = false;
}

function computeTime() {
  const result = computeAppointmentDuration(durationConfig.value, {
    finalLength: store.finalLength,
    services: services.value,
    details: {
      coupeDetails: coupeDetails.value,
      couleurDetails: couleurDetails.value,
      mecheDetails: mecheDetails.value
    }
  });

  console.log("Appointment duration trace", result.trace);

  store.$patch((state) => {
      state.duration = result.duration;
  });
}

function validateForm() {
            if (services.value.length == 0)
                validationErrors.value['services'] = true;
            else
                delete validationErrors.value['services'];

            return !Object.keys(validationErrors.value).length;
}
</script>
